// Validation constants
export const EPSILON = 0.01; // For floating point comparisons

// Default values
export const DEFAULT_TRANSACTION_AMOUNT = "";
export const DEFAULT_SHOP_NAME = "";

// Error messages
export const ERROR_MESSAGES = {
  SPLIT_MISMATCH: "Split amounts must add up to the total amount",
  INVALID_AMOUNT: "Please enter a valid amount",
  REQUIRED_FIELD: "This field is required",
} as const;

// UI constants
export const ICON_SIZES = {
  SMALL: 14,
  MEDIUM: 16,
  LARGE: 48,
} as const;
